<template>

<button class="oct-btn oct-btn-sm rounded border" v-if="status=='init'">
    <span class="material-symbols-outlined spin" >progress_activity</span>
    <span class="oct-btn-text" v-if="status=='init'">Chargement...</span>
</button>

<button class="oct-btn oct-btn-sm rounded border"
    @click="OEGDCancelCurrent"
        v-else-if="status=='busy'" >
    <span class="material-symbols-outlined spin" >autostop</span>
    <span class="oct-btn-text">{{ current.export.name }}</span>
</button>

<button class="oct-btn oct-btn-sm rounded border"
    @click="CtxMenuOpen($event, { menu })"
        v-else>
    <span class="material-symbols-outlined oct-btn-icon">{{ icon }}</span>
    <span class="oct-btn-text">{{ title }}</span>
</button>
</template>

<script>
import pagination from "@/libraries/exports/index.js";
export default {
    mixins: [pagination],
}
</script>

